import _upperFirst from "lodash/upperFirst";
function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }
  return _typeof(obj);
}
function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}
function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}
function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }
  return _assertThisInitialized(self);
}
function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return _setPrototypeOf(o, p);
}
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
import * as React from 'react';
import classnames from 'classnames';
import injectStyles from '../jss';
import Spinner from '../Spinner';
import styles from './Button.jss';
import { IconExternal } from '../Icons';
import { Link } from 'react-router';
export var Button = /*#__PURE__*/
function (_React$PureComponent) {
  _inherits(Button, _React$PureComponent);
  function Button() {
    var _getPrototypeOf2;
    var _this;
    _classCallCheck(this, Button);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Button)).call.apply(_getPrototypeOf2, [this].concat(args)));
    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleClick", function (event) {
      var _this$props = _this.props,
        disabled = _this$props.disabled,
        onClick = _this$props.onClick;
      if (typeof window === 'undefined' || disabled) {
        event.preventDefault();
        return;
      }
      if (typeof onClick === 'function') {
        onClick(event);
      }
    });
    return _this;
  }
  _createClass(Button, [{
    key: "getBaseElement",
    value: function getBaseElement() {
      var _this$props2 = this.props,
        external = _this$props2.external,
        to = _this$props2.to;
      if (to) {
        return external ? 'a' : Link;
      }
      return 'button';
    }
  }, {
    key: "getButtonProps",
    value: function getButtonProps() {
      var _this$props3 = this.props,
        external = _this$props3.external,
        name = _this$props3.name,
        to = _this$props3.to,
        type = _this$props3.type; // <button> props

      if (!to) {
        return {
          type: type,
          name: name
        };
      } // <a> props

      if (external) {
        return {
          href: to,
          target: '_blank'
        };
      } // <RouterLink> props

      return {
        to: to
      };
    }
  }, {
    key: "renderIcon",
    value: function renderIcon() {
      var _this$props4 = this.props,
        classes = _this$props4.classes,
        icon = _this$props4.icon;
      if (!icon) {
        return null;
      }
      var Icon = icon;
      return React.createElement(Icon, {
        className: classes.icon
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _classnames;
      var _this$props5 = this.props,
        children = _this$props5.children,
        classes = _this$props5.classes,
        classNameProp = _this$props5.className,
        customProps = _this$props5.customProps,
        disabled = _this$props5.disabled,
        fullWidth = _this$props5.fullWidth,
        colors = _this$props5.globals.colors,
        hasExternalIcon = _this$props5.hasExternalIcon,
        id = _this$props5.id,
        kind = _this$props5.kind,
        loading = _this$props5.loading,
        loadingText = _this$props5.loadingText,
        size = _this$props5.size,
        style = _this$props5.style;
      var className = classnames(classes.base, classes["kind".concat(_upperFirst(kind))], (_classnames = {}, _defineProperty(_classnames, classes.fullWidth, fullWidth), _defineProperty(_classnames, classes.disabled, disabled), _defineProperty(_classnames, classes.loading, loading), _defineProperty(_classnames, classes["size".concat(_upperFirst(size))], size), _classnames), classNameProp);
      var Element = this.getBaseElement();
      return React.createElement(Element, _extends({
        className: className,
        disabled: disabled,
        id: id,
        onClick: this.handleClick,
        style: style
      }, this.getButtonProps(), customProps), this.renderIcon(), React.createElement("span", null, loading && React.createElement(Spinner, {
        color: ['simple', 'white'].includes(kind) ? colors.whiteDark : colors.white
      }), loading && loadingText || children), hasExternalIcon && React.createElement(IconExternal, {
        className: classes.externalIcon,
        size: 10
      }));
    }
  }]);
  return Button;
}(React.PureComponent);
_defineProperty(Button, "styleRoot", 'Button');
_defineProperty(Button, "defaultProps", {
  disabled: false,
  kind: 'primary',
  loading: false,
  type: 'button'
});
export default injectStyles(styles)(Button);